import React, { useContext, useEffect, useState } from "react";
import { OperationContext } from "../../CreateOperation";
import { usePointingBagStore } from "../../../../store/PointingStore";
import { useSearchParams } from "react-router";
import { ColumnItem } from "../../../../../../common/models/table";
import { PointingService } from "../../../../core/_request";
import { HttpStatusCode } from "axios";
import { Loader } from "../../../../../../common/components/Loader/Loader";
import { LFTableV3 } from "../../../../../../common/components/LFTable/LFTableV3";
import { ActionsKey } from "../../../../../../common/models/Actions";
import { CustomDrawer } from "../../../../../../common/components/Drawer/CustomDrawer";
import { BagDetails } from "../details/bagDetails/BagDetails";
import { useOperationType } from "../../../../core/_context";

export const LandingBagPointingList = () => {
  const { initialValue } = useContext(OperationContext);

  const {
    list,
    pageState,
    totalItems,
    setList,
    resetPageState,
    setPageState,
    actioned,
    setActioned,
  } = usePointingBagStore();
  const [searchParams] = useSearchParams();
  const movement = searchParams.get("movment");
  const type = searchParams.get("type");

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isShowDrawer, setIsShowDrawer] = useState<boolean>(false);

  const operationType = useOperationType();

  const cols: ColumnItem[] = [
    {
      key: "batchNumber",
      title: "Numéro de Lot",
      dataIndex: "batchNumber",
      searchKey: "uniqueIdentifier",
      searchType: "text",
      show: true,
      // isCanSort: true,
    },
    {
      key: "designation",
      title: "Désignation",
      dataIndex: "designation",
      show: true,
      // isCanSort: true,
    },
    ...(operationType === "sales"
      ? [
        {
          key: "totalOnBoardTxt",
          title: "Total à bord (Qté/T)",
          dataIndex: "totalOnBoardTxt",
          show: true,
          // isCanSort: true,
        } as ColumnItem,
        {
          key: "remainingOnBoardTxt",
          title: "Restant à bord (Qté/T)",
          dataIndex: "remainingOnBoardTxt",
          show: true,
          // isCanSort: true,
        } as ColumnItem,
      ] : []
    ),
    {
      key: "totalDocksideTxt",
      title: "Total à quai (Qté/T)",
      dataIndex: "totalDocksideTxt",
      show: true,
      // isCanSort: true,
    },

    {
      key: "remainingDocksideTxt",
      title: "Restant à quai (Qté/T)",
      dataIndex: "remainingDocksideTxt",
      show: true,
      // isCanSort: true,
    },

    {
      key: "totalStorageTxt",
      title: "Total entreposage (Qté/T)",
      dataIndex: "totalStorageTxt",
      show: true,
      // isCanSort: true,
    },

    {
      key: "remainingStorageTxt",
      title: "Restant entreposage (Qté/T)",
      dataIndex: "remainingStorageTxt",
      show: true,
      // isCanSort: true,
    },
    {
      key: "overageTxt",
      title: "Overage (Qté/T) ",
      dataIndex: "overageTxt",
      show: true,
      // isCanSort: true,
    },
  ];

  useEffect(() => {
    const statuses = initialValue?.debarkationMovement?.loadPossessionStatus;
    if (!movement || !Array.isArray(statuses) || statuses.length === 0) return;

    let selected;

    if (type) {
      selected = statuses.find((item) => item.id === type.toUpperCase());
      if (!selected) return;
    } else {
      selected = statuses.length === 1 ? statuses[0] : null;
    }

    if (type && selected?.id !== type.toUpperCase()) return;

    if (selected?.url) {
      getMovement(`${selected.url}/controlled`, {
        ...pageState,
        "movement.id": movement,
        isLoadControlled: true,
        "order[inspectionOnBoardStartAt]": operationType === "sales" ?  "asc" : null,
        "order[inspectionDocksideStartAt]": operationType === "cabotage" ?  "asc" : null,
      });
    }
  }, [movement, pageState, type, initialValue?.debarkationMovement]);

  const getMovement = async (url: string, params: any) => {
    try {
      setIsLoading(true);

      const res = await PointingService.getAllMouvement(url, params);

      if (res?.status === HttpStatusCode.Ok) {
        setList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleShowDrawer = () => {
    setIsShowDrawer((prev: boolean) => !prev);
  };

  const onActionClick = (item: any, action: ActionsKey) => {
    handleShowDrawer();
    setActioned({
      data: item,
      action,
    });
  };

  return (
    <div>
      <Loader isLoading={isLoading} />
      <LFTableV3
        columns={cols}
        data={list}
        params={pageState}
        onAction={onActionClick}
        isCanShow={() => true}
        onSearch={setPageState}
        onSort={setPageState}
        onResetSearch={resetPageState}
        pagination={{
          defaultCurrentPage: pageState.page,
          itemsPerPage: pageState?.itemsPerPage,
          totalItems: totalItems,
        }}
        onChangePage={setPageState}
      />
      {isShowDrawer && (
        <CustomDrawer
          isOpen={isShowDrawer}
          onClose={handleShowDrawer}
          title={"Détails"}
        >
          <BagDetails initialValue={actioned?.data} />
        </CustomDrawer>
      )}
    </div>
  );
};
